import React from 'react';

// components
import Main from './components/Main/Main';

// css & media
import './App.css';

export default function App() {
  return (<>
  <Main />
  </>);
};
